import MUTATION from 'Root/Pages/Folder/Component/ElementsPane/move-elements-to-folder.graphql'

import React, { Fragment } from 'react'

import classNames from 'classnames'
import { Visibility } from 'globalTypes'
import { isNull } from 'lodash'

import { useMutation, useQuery } from '@apollo/client'
import { Trans } from '@lingui/macro'
import Loading from 'Root/Loader/Page'
import map from 'lodash/map'

import MUTATION_HOME from './move-to-homepage.graphql'
import QUERY from './move-to-targets.graphql'

const getFolderVisibilityByElementVisibility = (elementVisibility) => {
  let folderVisibilities = [
    Visibility.public,
    Visibility.preview,
    Visibility.protected,
  ]

  if (elementVisibility === Visibility.mine) {
    folderVisibilities = [Visibility.protected]
  }

  if (elementVisibility === Visibility.protected) {
    folderVisibilities = [Visibility.protected]
  }

  if (elementVisibility === Visibility.preview) {
    folderVisibilities = [Visibility.protected, Visibility.preview]
  }

  return folderVisibilities
}

const AssociateToFolders = ({
  id,
  visibility,
  parent_folder_id,
  __typename,
}) => {
  let targets = []

  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: 'network-only',
  })

  const [mutate, { loading: isMutating }] = useMutation(MUTATION, {
    refetchQueries: ['HomeElements'],
  })

  const [mutateHome] = useMutation(MUTATION_HOME, {
    refetchQueries: ['FolderPage'],
  })

  const onChange = (element) => () => {
    if (element.id === 'home') {
      mutateHome({
        variables: {
          elementId: id,
          type: __typename,
        },
      })
    } else {
      mutate({
        variables: {
          folderId: element.id,
          elements: [
            {
              elementId: id,
              elementType: __typename,
            },
          ],
        },
      })
    }
  }

  if (!isNull(parent_folder_id)) {
    targets = data?.me?.userFolders?.filter(
      (folder) => folder.id !== parent_folder_id
    )
    targets = [
      ...(targets ?? []),
      {
        title: <Trans>Riporta in homepage</Trans>,
        id: 'home',
        visibility: Visibility.protected,
      },
    ]
  } else {
    targets = data?.me?.userFolders
  }

  if (loading) {
    return <Loading />
  }

  targets = targets
    ?.filter((target) => target.id !== id)
    ?.filter((target) =>
      getFolderVisibilityByElementVisibility(visibility).includes(
        target.visibility
      )
    )

  return (
    <Fragment>
      <div className="text-2xl border-b border-gray-300 p-2">
        <Trans>Sposta elemento in:</Trans>
      </div>
      <ul className="divide-y divide-gray-200">
        {map(targets, (target) => (
          <li key={target.id} className="p-4">
            <label
              className={classNames(
                {
                  'opacity-50': isMutating,
                },
                'inline-flex items-center cursor-pointer'
              )}
            >
              <input
                className="cursor-pointer form-checkbox h-8 w-8 rounded-md border-gray-300 p-4"
                defaultChecked={target.includes}
                onChange={onChange(target)}
                type="checkbox"
                disabled={isMutating}
              />
              <span className="ml-4 text-xl">{target.title}</span>
            </label>
          </li>
        ))}
      </ul>
    </Fragment>
  )
}

export default AssociateToFolders
